// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;&#145;So I swore in my wrath,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;&#147;They shall not enter into my rest.&#148; &#146;<br> </p> </div></div>";
// Exports
module.exports = code;